module.exports = __webpack_public_path__ + "img/no-data.dacc93b5.png";